import EventBus from "@/eventBus";
import {ALERT} from '../../constants/alert.js'
import CalendarService from "../../services/calendarService.js";
import OdService from "../../services/odService.js";
import { CALENDAR_ROLES, CALENDAR_TYPES, EVENT_STATUS } from "../../constants/constantsValues.js";
import { hashedColor } from "../../util/colorUtil.js"
import dayjs from "dayjs";
import { DateTime } from 'luxon';
export const moduleCalendar = {
  namespaced: true,
  state: {
    currentCalendar : {},

    invites : {},
   
    calendarList : [], // all calendars for the user

    isLoading : false,

    scheduleEvents : [],

    doctors : {},

    clinics : {},

    authors : {}, // Event Created by


  },
  getters : {
    calendarList(state){
      return state.calendarList;
    },
    currentCalendar(state){
      return state.currentCalendar;
    },
    isLoading(state){
      return state.isLoading;
    },
    scheduleEvents(state){
      return state.scheduleEvents;
    },
    canEditCalendar(state, getters, rootState){
      let user_id = rootState?.user?.user_id;
    
      if(Object.keys(state.currentCalendar).length === 0) return false;
       return state.currentCalendar.calendar_members?.some(
        member => member.user_id == user_id && (member.role == CALENDAR_ROLES.OWNER || member.role == CALENDAR_ROLES.EDITOR));
    },
    isODCalendar(state){
      return state.currentCalendar?.type == CALENDAR_TYPES.OD;
    },
    doctorsList(state){
      return Object.values(state.doctors);
    },
    clinics(state){
      return state.clinics;
    },
    allClinics(state){
      return Object.values(state.clinics);
    },
    authorsList(state){
      return Object.values(state.authors);
    },
    isDSSCalendar(state){
      return state.currentCalendar?.type == CALENDAR_TYPES.DSS;
    },
    isGoogleCalendar(state){
      return state.currentCalendar?.type == CALENDAR_TYPES.GOOGLE;
    }
  },
  mutations : {
    calendarList(state, value){
      state.calendarList = value;
    },
    currentCalendar(state, value){
      state.currentCalendar = value;
    },
    addCalendar(state, value){
      state.calendarList.push(value);
    },
    updateCalendar(state, value){
      const index = state.calendarList.findIndex(calendar => calendar.calendar_id == value.calendar_id);
      if (index !== -1) {
        state.calendarList.splice(index, 1, value);
      }
      if(state.currentCalendar.calendar_id == value.calendar_id){
        state.currentCalendar = {...value};
      }
    },
    addCalendarMember(state, value){
      if(state.currentCalendar.calendar_id == value.calendar_id){
        state.currentCalendar.calendar_members.push({user_id : value.user_id, role : value.role});
        EventBus.$emit("calenderMemberAdded", {user_id : value.user_id, role : value.role});
      }
    },
    updateCalendarMemberRole(state, value){
      if(state.currentCalendar.calendar_id == value.calendar_id){
        const member = state.currentCalendar.calendar_members.find(member => member.user_id == value.user_id);
        if (member) {
          member.role = value.role;
        }
      }
    },
    removeCalendarMember(state, value){
      if(state.currentCalendar.calendar_id == value.calendar_id){
        state.currentCalendar.calendar_members = state.currentCalendar.calendar_members.filter(member => member.user_id != value.user_id);
        EventBus.$emit("calenderMemberRemoved", value.user_id);
      }
    },
    scheduleEvents(state, value){
      state.scheduleEvents = value;
    },
    changeLoading(state, value){
      state.isLoading = value;
    },
    doctors(state, value){
      state.doctors = value;
    },
    clinics(state, value){
      state.clinics = value;
    },
    authors(state, value){
      state.authors = value;
    },
    appendEvent(state, value){
      state.scheduleEvents = [...state.scheduleEvents, ...value];
    },
    removeEvent(state, event){
      if(state.currentCalendar.calendar_id != event.calendar_id){
        return;
      }
      state.scheduleEvents = state.scheduleEvents.filter(e => e.event_id != event.event_id);
    },
    updateEventTime(state, event){
      if(state.currentCalendar.calendar_id != event.calendar_id){
        return;
      }
      state.scheduleEvents.forEach((e, i) => {
        if (e.event_id === event.event_id) {
          state.scheduleEvents[i].start = dayjs(event.start_time).format("YYYY-MM-DD HH:mm");
          state.scheduleEvents[i].end =  dayjs(event.end_time).format("YYYY-MM-DD HH:mm");
        }
      });
    }
  },
  actions : {
    async getCalendars({ commit }){
        try {
            let res = await CalendarService.getCalendars();
            commit("calendarList",res.data.calendars);
        } catch (error) {
            console.error(error);
        }
    },
    async getcalendarById({commit}, payload){
        try {
            let res = await CalendarService.getCalendarById(payload);
            commit("currentCalendar", res.data.calendar);
        } catch (error) {
            console.error(error);
        }
    },
    async createCalendar({commit},payload){
        try {
            let res = await CalendarService.createCalendar(payload);
           if(res.status === 201){
                EventBus.$emit("alert", { message: "Calendar created successfully", type: ALERT.SUCCESS });
            }
            
        } catch (error) {
            console.error(error);
            EventBus.$emit("alert",{ message: "Failed to create calendar", type: ALERT.ERROR});
        }
    },
    async updateCalendar({commit, state}, payload){
        try {
            let res = await CalendarService.updateCalendar(state.currentCalendar.calendar_id, payload);
            EventBus.$emit("alert",{ message: "Calendar updated successfully", type: ALERT.SUCCESS});
        } catch (error) {
            console.error(error);
            EventBus.$emit("alert",{ message: "Failed to update calendar", type: ALERT.ERROR});
        }
    },
     async updateCalendarMemberRole({state},payload){
        try {
          await CalendarService.updateCalendarMemberRole(state.currentCalendar.calendar_id, payload.user_id, {role :payload.role});
        } catch (error) {
          console.error(error);
        }
    },
    async addCalendarMember({state}, payload){
        try {
            await CalendarService.addCalendarMember(state.currentCalendar.calendar_id, payload);
        }  catch (error) {
            console.error(error);
        }
    },
    async removeCalendarMember({commit, state}, payload){
        try {
            await CalendarService.removeCalendarMember(state.currentCalendar.calendar_id, payload.user_id);
        }  catch (error) {
            console.error(error);
        }
    },
    async addEventMember({state, dispatch}, payload){
       try {
        await CalendarService.handleEventparticipants(state.currentCalendar.calendar_id, payload.event_id, payload.data);
      } catch (error) {
        console.error(error);
        dispatch("getEventById", {calendar_id: state.currentCalendar.calendar_id, event_id: payload.event_id});
      }
    },
    async removeEventMember({state, dispatch}, payload){
       try {
        await CalendarService.handleEventparticipants(state.currentCalendar.calendar_id, payload.event_id, payload.data);
      } catch (error) {
        console.error(error);
        dispatch("getEventById", {calendar_id: state.currentCalendar.calendar_id, event_id: payload.event_id});
      }
    },
    async updateEventTime({state, dispatch}, payload){
       try {
        await CalendarService.updateEventTime(state.currentCalendar.calendar_id, payload.event_id, payload.data);
      } catch (error) {
        console.error(error);
        dispatch("getEventById", {calendar_id: state.currentCalendar.calendar_id, event_id: payload.event_id});
      }
    },
    async createEvent({ commit, state }, payload) {
      try {
        const calendar_id = state.currentCalendar.calendar_id;
        const res = await CalendarService.addEvent(calendar_id, payload);
        if (res.status === 201) {
          EventBus.$emit("alert", { message: "Event added successfully", type: ALERT.SUCCESS });
        }
      } catch (error) {
        console.error(error);
        EventBus.$emit("alert", { message: "Failed to add event", type: ALERT.ERROR });
      }
    },
    async updateEvent({ commit, state }, payload) {
      try {
        const calendar_id = state.currentCalendar.calendar_id;
        const event_id = payload.event_id;
        const res = await CalendarService.updateEvent(calendar_id, event_id, payload.data);
        if (res.status === 200) {
          EventBus.$emit("alert", { message: "Event updated successfully", type: ALERT.SUCCESS });
        }
      } catch (error) {
        console.error(error);
        EventBus.$emit("alert", { message: "Failed to update event", type: ALERT.ERROR });
      }
    },
   
    // DSS Calendar
    async getDSSEvents({ commit, state, dispatch  }, date) {
      try {
        const calendar_id = state.currentCalendar.calendar_id;
        
        if (!calendar_id) {
          console.warn("No current calendar selected to fetch events.");
          return;
        }
        commit("changeLoading", true);
        commit("scheduleEvents", []);
        commit("authors", {});
        const fetchedEvents = await CalendarService.getEvents(calendar_id, date);
        let events = [];
        if (fetchedEvents.data.events?.length) {
          events = await dispatch("formatDSSEvents", fetchedEvents.data.events);
        }
        commit("scheduleEvents", events);
       
        commit("changeLoading", false);
      } catch (error) {
        commit("changeLoading", false);
        console.error("Failed to fetch events:", error);
        EventBus.$emit("alert", { message: "Failed to fetch events", type: ALERT.ERROR });
      }
    },
    //OD Calendar
    async fetchODAppointments({ commit, state }, date){
      try {
       const calendar_id = state.currentCalendar.calendar_id;
        if (!calendar_id) {
          console.warn("No current calendar selected to fetch events.");
          return;
        }
        commit("changeLoading", true);
        commit("scheduleEvents", []);
        commit("doctors", {})
        // Fetch appointments from Open Dental
        const response = await OdService.getAppointments(date, 0);

        if (response.data && response.data.length > 0) {
          const events = [];
          for (let i = 0; i < response.data.length; i++) {
            const appointment = response.data[i];
            if (!Array.isArray(appointment.od_json)) continue;

            appointment.od_json.forEach(od => {
              if (!od) return;
              if (od.Op === 0) {
                EventBus.$emit("unknownOperatory", od.ClinicNum);
              }
              state.doctors[od.provAbbr] = { provAbbr: od.provAbbr };

              events.push({
                start: dayjs(od.AptDateTime).format("YYYY-MM-DD HH:mm"),
                end: dayjs(od.AptDateTime)
                  .add(od.Pattern.length * 5, "minutes")
                  .format("YYYY-MM-DD HH:mm"),
                title: od.provAbbr,
                schedule: `${od.Op}_${od.ClinicNum}`,
                backgroundColor: hashedColor(state.clinics[od.ClinicNum].clinicName),
                color: "#fff",
                ...appointment,
              });
            });
          }
          commit("scheduleEvents", events);
        }
        commit("changeLoading", false);
      } catch (error) {
        commit("changeLoading", false);
        EventBus.$emit("alert", { message: "Failed to fetch events", type: ALERT.ERROR });
        console.error("Error fetching appointments:", error);
      }
    },
    async fetchClinics({commit, state}){
        try {
          let res = await OdService.getClinics();
          let clinics = {};
          res.data.forEach((clinic) => {
            clinics[clinic.ClinicNum] = {clinicName : clinic.Description, ClinicNum : clinic.ClinicNum};
          });
          commit("clinics", clinics)
        } catch (error) {
          console.error(error); 
        }
    },
    async formatDSSEvents({commit, state, rootGetters}, fetchedEvents ){
      let events = [];
       
      events = fetchedEvents.flatMap(event => {
          const label = rootGetters['people/getUserName'](event.user_id);
          const userId = rootGetters['userId']
          state.authors[event.user_id] = { author: event.user_id, label : label };

          const eventEndTime = DateTime.fromMillis(event.end_time, { zone: event.timezone || 'local' });
          const now = DateTime.now().setZone(event.timezone || 'local');
          const isPastEvent = eventEndTime < now;

          return event.event_participants.filter(participant => participant.user_id !== null).map(participant => ({
              schedule: participant.user_id,
              start: dayjs(event.start_time).format("YYYY-MM-DD HH:mm"),
              end: dayjs(event.end_time).format("YYYY-MM-DD HH:mm"),
              title: event.title,
              content: event.description,
              allDay: event.all_day,
              class: event.all_day ? 'all-day-event' : '',
              author : event.user_id,
              backgroundColor : hashedColor(label),
              // To Edit or Delete current user should be the author of the event and event is not in the past and it should not completed event
              deletable : (userId == event.user_id) && !isPastEvent && event.status !== EVENT_STATUS.COMPLETED,
              draggable : (userId == event.user_id) && !isPastEvent && event.status !== EVENT_STATUS.COMPLETED,
              resizable : (userId == event.user_id) && !isPastEvent && event.status !== EVENT_STATUS.COMPLETED,
              ...event
        }));
      });
      return events;
    },
    async addCalendarEvent({commit, state, dispatch}, event ){
        try {
          if(state.currentCalendar.calendar_id != event.data.calendar_id){
            return;
          }

          let foramttedEvent = await dispatch("formatDSSEvents", [event.data]);
          commit("appendEvent",foramttedEvent);
        } catch (error) {
          console.error(error);
        }
    },
    async updateCalendarEvent({commit, state, dispatch}, event ){
        try {
         
          if(state.currentCalendar.calendar_id != event.calendar_id){
            return;
          }

          let foramttedEvent = await dispatch("formatDSSEvents", [event]);
          commit("removeEvent", event);
          commit("appendEvent",foramttedEvent);
        } catch (error) {
          console.error(error);
        }
    },
    async getEventById({commit, state, dispatch}, event ){
        try {
         
          if(state.currentCalendar.calendar_id != event.calendar_id){
            return;
          }
          let res = await CalendarService.getEventById(event.calendar_id, event.event_id);
         
          let foramttedEvent = await dispatch("formatDSSEvents", [res.data.event]);
          commit("removeEvent", event);
          commit("appendEvent",foramttedEvent);
        } catch (error) {
          console.error(error);
        }
    }
  }
}
